module.exports = __webpack_public_path__ + "static/media/warehouse.5092f124.svg";